"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createElement = void 0;
const string_to_dom_1 = __importDefault(require("string-to-dom"));
function createElement(template) {
    return (0, string_to_dom_1.default)(template);
}
exports.createElement = createElement;
